import { batch, signal, computed } from "@preact/signals-react"

import { commonFiltersValue } from "@signals"

export const stockAssDetailsIsEmpty = signal(false)
export const stockAssDetailsReportFormIsOpen = signal(false)

export const stockAssDetailsSummaryClickFilters = signal({})
export const stockAssDetailsSummaryFilters = computed(() => ({
    ...commonFiltersValue.value,
    ...stockAssDetailsSummaryClickFilters.value
}))

export const stockAssDetailsNotListedFilters = signal({})
export const stockAssDetailsEvolutionFilters = signal({})
export const stockAssDetailsEvolutionCurrentPeriod = signal("")
export const stockAssDetailsEndDate = signal("")

export const stockAssDetailsWidgetEvolutionFilters = signal({})

export const elementsInLoading = signal([])

export const resetStockAssDetails = () => batch(() => {
    stockAssDetailsIsEmpty.value = false
    stockAssDetailsSummaryClickFilters.value = {}
    stockAssDetailsNotListedFilters.value = {}
    stockAssDetailsEvolutionFilters.value = {}
    elementsInLoading.value = []
})